export default function YoutubeVideo({ videoId }: { videoId: string }) {
  return (
    <div>
      <iframe
        style={{ aspectRatio: "16 / 9", width: "100%" }}
        src={`https://www.youtube.com/embed/${videoId}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
}
